import React, { useState } from "react";
import { TwoRow } from "../../core/layouts";
import HeadingContainer from "../HeadingContainer";
import Style from "./AddSubCategoryFormContainer.module.scss";
import variables from "../../themes/base/styles/variables";
import SubCategoriesFieldsContainer from "../SubCategoryFieldFormContainer";
import { getLocalizedMessage } from "../../UtilityFunctions/utils";
import { useIntl } from "react-intl";
import { Space, Button } from "react_reusable_components";

const SubCategoryFormStyle = {
  topSectionStyle: { padding: `0 ${variables.paddingMedium}` },
  bottomSectionStyle: {
    marginTop: variables.marginMedium,
    flex: 1,
    overflowY: "auto",
    width: variables.fullWidth,
  },
  bottomWrapper: { width: variables.fullWidth },
  twoRowTopSectionStyle: {
    display: variables.dFlex,
    flexDirection: "column",
    width: variables.fullWidth,
    gap: variables.gapSmaller,
    maxHeight: "calc(100% - 6.5rem)",
    overflowY: "auto",
    padding: `0 ${variables.paddingMedium}`,
  },
};

export default function AddSubCategoryFormContainer({
  removeSubProductCategory,
  addSubProductCategory,
  values,
  handleSubProductCategoryChange,
  handleChange,
  AddProductCategoryFormFieldName,
  isEditMode,
}) {
  const [userInput, setUserInput] = useState(false);

  const intl = useIntl();
  return (
    <TwoRow
      topSection={
        <HeadingContainer
          heading={getLocalizedMessage(
            intl,
            "productCategory.subProductCategory"
          )}
          headingClassName={Style["ProductCategoryForm-heading"]}
          description={getLocalizedMessage(
            intl,
            "productCategory.addSubProductCategory"
          )}
          descriptionClassName={Style["ProductCategoryForm-description"]}
        />
      }
      topSectionStyle={SubCategoryFormStyle.topSectionStyle}
      bottomSectionStyle={SubCategoryFormStyle.bottomSectionStyle}
      bottomSection={
        <TwoRow
          topSectionStyle={SubCategoryFormStyle.twoRowTopSectionStyle}
          bottomSectionStyle={{
            padding: `0 ${variables.paddingMedium}`,
          }}
          topSection={
            <SubCategoriesFieldsContainer
              removeSubProductCategory={removeSubProductCategory}
              addSubProductCategory={addSubProductCategory}
              values={values}
              handleSubProductCategoryChange={handleSubProductCategoryChange}
              handleChange={handleChange}
              AddProductCategoryFormFieldName={AddProductCategoryFormFieldName}
              userInput={userInput}
              setUserInput={setUserInput}
              isEditMode={isEditMode}
            />
          }
          bottomSection={
            <Space size={0} className={Style["sticky-add-btn"]}>
              <Button
                className={Style["add-more"]}
                ghost
                onClick={addSubProductCategory}
                icon={null}
              >
                <img
                  alt={"icon"}
                  src="/icons/add.svg"
                  className={Style["icon"]}
                />
                {getLocalizedMessage(intl, "productCategory.addMore")}
              </Button>
            </Space>
          }
        />
      }
    />
  );
}
